import { useEffect } from 'react';

const useIntersectionObserver = (elements = [], callback, options) => {
    useEffect(() => {
        if (!window || !window.IntersectionObserver || typeof window.IntersectionObserver !== 'function') { return; }

        const observer = new IntersectionObserver((entries) => callback(entries), options);

        elements.forEach((el) => {
            el && observer.observe(el);
        });

        return () => {
            observer.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...elements, callback]);
};

export default useIntersectionObserver;
